export var GitProvider;
(function (GitProvider) {
    GitProvider["GIT_PROVIDER_GITHUB"] = "GITHUB";
})(GitProvider || (GitProvider = {}));
